/**
 * åªè¦æä¸ä¸ªæ»¡è¶³æ¡ä»¶å°±è¿å true
 * @param arr
 * @param func
 */
var some = function (arr, func) {
    for (var i = 0; i < arr.length; i++) {
        if (func(arr[i], i))
            return true;
    }
    return false;
};
export default some;
//# sourceMappingURL=some.js.map